var _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgConsultation = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 10.4346,
    x2: 35.3902,
    y2: 10.4346,
    stroke: "#283333",
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: 18.5449,
    x2: 35.3902,
    y2: 18.5449,
    stroke: "#283333",
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 26.6548,
    x2: 35.3902,
    y2: 26.6548,
    stroke: "#283333",
    strokeWidth: 1.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 2.32422,
    x2: 35.3902,
    y2: 2.32422,
    stroke: "#283333",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.37298,
    cy: 2.94919,
    r: 2.94919,
    fill: "#283333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4918,
    cy: 11.0595,
    r: 2.94919,
    fill: "#283333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6443,
    cy: 19.1699,
    r: 2.94919,
    fill: "#283333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3222,
    cy: 27.2798,
    r: 2.94919,
    fill: "#283333"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConsultation);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzNiAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeTE9IjEwLjQzNDYiIHgyPSIzNS4zOTAyIiB5Mj0iMTAuNDM0NiIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGxpbmUgeTE9IjE4LjU0NDkiIHgyPSIzNS4zOTAyIiB5Mj0iMTguNTQ0OSIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGxpbmUgeTE9IjI2LjY1NDgiIHgyPSIzNS4zOTAyIiB5Mj0iMjYuNjU0OCIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGxpbmUgeTE9IjIuMzI0MjIiIHgyPSIzNS4zOTAyIiB5Mj0iMi4zMjQyMiIgc3Ryb2tlPSIjMjgzMzMzIiBzdHJva2Utd2lkdGg9IjEuMjUiLz4KPGNpcmNsZSBjeD0iNy4zNzI5OCIgY3k9IjIuOTQ5MTkiIHI9IjIuOTQ5MTkiIGZpbGw9IiMyODMzMzMiLz4KPGNpcmNsZSBjeD0iMjkuNDkxOCIgY3k9IjExLjA1OTUiIHI9IjIuOTQ5MTkiIGZpbGw9IiMyODMzMzMiLz4KPGNpcmNsZSBjeD0iMjAuNjQ0MyIgY3k9IjE5LjE2OTkiIHI9IjIuOTQ5MTkiIGZpbGw9IiMyODMzMzMiLz4KPGNpcmNsZSBjeD0iMTAuMzIyMiIgY3k9IjI3LjI3OTgiIHI9IjIuOTQ5MTkiIGZpbGw9IiMyODMzMzMiLz4KPC9zdmc+Cg==";